export default __webpack_public_path__ + "img/deliveries.d6e3d0.svg";